// extracted by mini-css-extract-plugin
module.exports = {"powerStreamDetail":"detail_powerStreamDetail__g1G75"};